import React from "react";
import { TextField } from "@mui/material";

const MyDatePicker = ({ label = "Date", value, onChange }) => {
  return (
    <TextField
      type="date"
      label={label}
      value={value}
      onChange={onChange}
      slotProps={{
        inputLabel: {
          shrink: true,
        },
      }}
      size="small"
      fullWidth
    />
  );
};

export default MyDatePicker;
